import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectReference} from '../models/project-reference';
import {TeamMember} from '../models/team-member';
import {ProjectReferenceDetailResponse} from '../models/project-reference-detail.response';
import {Link, LinkType} from '../models/link';

export interface LinkService {
    create(refId: number, teamMember: Link): Observable<Link>;
    update(refId: number, teamMember: Link): Observable<Link>;
    delete(refId: number, teamMember: Link): Observable<void>;
    list(refId: number): Observable<Link[]>;
    listLinkTypes(): Observable<LinkType[]>;
}

@Injectable()
export class LinkServiceImpl implements LinkService {
    protected http = inject(HttpClient);


    listLinkTypes(): Observable<LinkType[]> {
        return this.http.get<LinkType[]>(`/api/v1/links/types`);
    }

    create(refId: number, link: Link): Observable<Link> {
        return this.http.post<Link>(`/api/v1/project-references/${refId}/links`, {
            name: link.name,
            type: link.type.key,
            link: link.link
        });
    }

    delete(refId: number, link: Link): Observable<void> {
        return this.http.delete<void>(`/api/v1/project-references/${refId}/links/${link.id}`);
    }

    update(refId: number, link: Link): Observable<Link> {
        return this.http.put<Link>(`/api/v1/project-references/${refId}/links/${link.id}`, {
            id: link.id,
            name: link.name,
            type: link.type.key,
            link: link.link
        });
    }

    list(refId: number): Observable<Link[]> {
        return this.http.get<Link[]>(`/api/v1/project-references/${refId}/links`);
    }
}
